export default __webpack_public_path__ + "static/media/trappist-1-system.06f8283c.png";